import { render } from "./TheCartOrderFast.vue?vue&type=template&id=fe4bd61a"
import script from "./TheCartOrderFast.vue?vue&type=script&lang=js"
export * from "./TheCartOrderFast.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/application/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__